import _ from "lodash";

export function getTitleByObject(object: Record<string, any>): string[] {
  return _.values(object)
    .filter(Boolean)
    .map((f) => f?.title);
}
